import { timeFormat, numberFormat } from "@custom/index";

export const tableColumn = [
    {
        type: "index",
        label: "序号",
        width: 80,
    },
    {
        prop: "statusName",
        label: "公告状态",
        width: 100,
    },
    {
        prop: "title",
        label: "公告标题",
    },
    {
        prop: "details",
        label: "公告内容",
    },
    {
        prop: "publisher",
        label: "公告落款",
        width: 100
    },
    {
        label: "公告发布时间",
        render: (h, {row}) => {
            return row.publishTime ? timeFormat(new Date(row.publishTime),"yyyy-MM-dd ") : "";
        }
    },  
      {
        prop: "operator",
        label: "操作人",
        width: 100
    },
    {
        label: "操作时间",
        render: (h, {row}) => {
            return row.upDate ? timeFormat(new Date(row.upDate),"yyyy-MM-dd HH:mm:ss") : "";
        }
    },

];